import { CardModel } from './card';

export class DeckModel {
    public name: string;
    public cards: CardModel[];
    public card_count?: number;
    public id?: string;
    /**
     * The firebase auth.uid of the user that created the deck
     */
    public createdBy: string;
    /**
     * Timestamp when the deck was created
     */
    public createdAt: any;
    /**
     * Timestamp when the deck was last updated
     */
    public lastupdatedAt?: any;
    
    public roles: any;
    public uploaded?: boolean;
    public visibility?: string;
    public desc?: string;
}
